export default {

  'overview_Key_Performance_Metrics': 'Key Metrics',
  // 卡片标题和文字
  'overview_Revenue($)': 'Revenue({unit})',
  'overview_New': 'New',
  'overview_ARPU($)': 'ARPU({unit})',
  'overview_Payer%': 'Payer%',
  'overview_change': 'Change', // 32
  'overview_change_amount': 'Change',


  // Engagement Metrics Trends
  'overview_Engagement_Metrics_Trends': 'Engagement Metrics Trends', // 15

  'overview_TRU': 'TNU', // 19
  'overview_PCU': 'PCU', // 20
  'overview_AOT(min)': 'Avg.Playtime(min)', // 21
  'overview_Avg_Daily_Playtime(min)': 'Avg.Daily Playtime(min)',
  'overview_AOT': 'Avg.Playtime', // 21
  // segment组件指标解释： 日 WD2 WD3 WD7  周 WW2 WW3  月 WM2 WM3
  'overview_Weighted_D2': 'Day 2 weighted retention ratio.',
  'overview_Weighted_D3': 'Day 3 weighted retention ratio.',
  'overview_Weighted_D7': 'Day 7 weighted retention ratio.',
  'overview_Weighted_W2': 'Week 2 weighted retention ratio.',
  'overview_Weighted_W3': 'Week 3 weighted retention ratio.',
  'overview_Weighted_M2': 'Month 2 weighted retention ratio.',
  'overview_Weighted_M3': 'Month 3 weighted retention ratio.',


  // Revenue Metrics Trends
  'overview_Revenue_Metrics_Trends': 'Revenue Metrics Trends', // 24
  'overview_metics_time_Trends': 'playtime metrics', // 24

  'overview_ARPPU($)': 'ARPPU({unit})', // 26
  'overview_Payer': 'Payer', // 28

  // Overall Performance 宽表
  'overview_Overall_Performance': 'Overall Performance',
  'overview_close_progress': 'Hide Heat Map',
  'overview_show_progress': 'View Heat Map',
  'overview_Setting': 'Setting',
  'overview_Date': 'Date',

  'overview_ACU': 'ACU',
  'overview_New_Payer': 'First-time Payer',
  'overview_Register_Payer': 'Register Payer',
  'overview_Revenue(new_payer)': 'Revenue(first-time payer)',
  'overview_New_Users_ARPPU($)': 'First-time Payer ARPPU({unit})',
  'overview_Avg.Login_Count': 'Sessions per user',
  'overview_daily_Churn_Users': 'Churn Users',
  'overview_weekly_Churn_Users': 'Churn Users',
  'overview_monthly_Churn_Users': 'Churn Users',
  'overview_Churn%': 'Churn%',
  // Breakdown 图表模块

  'overview_New_Users': 'New Users', // 2
  'overview_Retention_Users': 'Retention Users', // 3
  'overview_Return_Users': 'Return Users', // 4
  'overview_Return_Daily': 'Return Users', // 4
  'overview_Return_Weekly': 'Return Users', // 4
  'overview_Return_Monthly': 'Return Users', // 4

  // Channels of New Users 图表模块
  'overview_Channels_of_New_Users': 'Channels of New Users', // 5
  'overview_System_of_New_Users': 'Platform of New Users', // 5

  // Country/Region/Zone Breakdown 模块
  'overview_Country/Region/Zone_Breakdown': 'Country/Region/Zone Breakdown', // 1
  'overview_Country': 'Country', // 2
  'overview_Countries': 'Countries', // 2
  'overview_Region': 'Region', // 3
  'overview_Regions': 'Regions', // 3
  'overview_Zone': 'Zone', // 4
  'overview_Zones': 'Zones', // 4
  'overview_of_Top_10': ' of Top 10 ',


  'overview_Share_Of_All': 'Share of All', // 7
  'overview_Sum_Revenue($)': 'Sum Revenue({unit})', // 9
  'overview_Sum_New': 'Sum New', // 11

  'overview_wow': 'WoW',
  'overview_swlm': 'SWLM',
  'overview_dod': 'DoD',
  'overview_sdlw': 'SDLW',
  'overview_mom': 'MoM',
  'overview_smly': 'SMLY',
  'overview_lost': 'LOST',

  // 待补充
  'overview_Last_Week': 'Last Week',
  'overview_Today': 'Today',
  'overview_Last_Month': 'Last Month',
  'overview_This_Week': 'This Week',
  'overview_Last_Year': 'Last Year',
  'overview_This_Month': 'This Month',

  'overview_Revenue': 'Revenue',
  'overview_ARPU': 'ARPU',
  'overview_Version': 'Version',

  // overview 宽表
  'overview_sum_tip': 'Display the aggregate values for the corresponding columns. Some metrics (such as total registered users and daily active users) do not support deduplication by user and will not be displayed.',

  // PC Console 模块
  'pc_overview_D1(T-1)': 'D1(T-1)',
  'pc_overview_Revenue': 'Revenue After Refund & Tax',
  'pc_overview_Revenue($)': 'Revenue After Refund & Tax({unit})',
  'pc_overview_Rev($)': 'Revenue After Refund & Tax({unit})',
  'pc_overview_Units': 'Base Game Units After Refund',
  'pc_overview_sum_units': 'Sum Base Game Units After Refund',
  'pc_overview_DLC_MTX_Revenue': 'DLC & In-Game Revenue',
  'pc_overview_MTX_Revenue': 'In-Game Revenue',
  'pc_overview_MTX_Revenue($)': 'In-Game Rev({unit})',
  'pc_overview_MTX_Payer': 'In-Game Payer',
  'pc_overview_MTX_Payer_Rate': 'In-Game Payer%',
  'pc_overview_DLC_MTX_ARPU': 'DLC & In-Game ARPU',
  'pc_overview_MTX_ARPU': 'In-Game ARPU',
  'pc_overview_ARPPU': 'ARPPU',
  'pc_overview_DLC_MTX_ARPPU': 'DLC & In-Game ARPPU',
  'pc_overview_MTX_ARPPU': 'In-Game ARPPU',
  'overview_Avg_PCU': 'Avg.PCU',
  'pc_overview_Avg_MTX_Payer': 'Avg.In-Game Payer',
  'overview_Avg_Payer': 'Avg.Payer',
  'pc_overview_MTX': 'In-Game',
  'pc_overview_DLC_Rev': 'DLC Rev',
  'pc_overview_DLC_Revenue': 'DLC Revenue',
  'pc_overview_DLC_Rev($)': 'DLC Rev({unit})',
  'pc_overview_MTX_Rev': 'In-Game Rev({unit})',
  'pc_overview_Units_Rev': 'Base Game Revenue After Refund & Tax',
  'pc_overview_Units_Rev($)': 'Base Game Revenue After Refund & Tax({unit})',
  'pc_overview_Units_Revenue': 'Base Game Revenue After Refund & Tax',
  'pc_overview_Digital_Rev': 'Digital Rev',
  'pc_overview_Digital_Revenue': 'Digital Revenue',
  'pc_overview_Physical_Rev': 'Physical Rev',
  'pc_overview_Physical_Revenue': 'Physical Revenue',
  'pc_overview_AVG_Login_Counts': 'Sessions per user',
  'pc_overview_Entitlement': 'Entitlement',
  'pc_overview_Time_to_Purchase': 'Time to Purchase (days)',
  'pc_overview_Time_to_Purchase_Trend': 'Time to Purchase',

  'nightingale_daily_revenue': 'Revenue',
  'nightingale_daily_reactivated': 'Reactivated',
  'nightingale_daily_asp': 'ASP',
  'nightingale_daily_refunds': 'Refunds',
  'nightingale_avg_asp': 'Avg.ASP',

  'nightingale_daily_asp$': 'ASP({unit})',
  'nightingale_daily_refunds$': 'Refunds({unit})',
  'nightingale_avg_asp$': 'Avg.ASP({unit})',
  'nightingale_sum_refunds$': 'Sum Refunds({unit})',
  'nightingale_sum_reactivated': 'Sum Reactivated',

  'nightingale_daily_accumulated_units': 'Accumulated Units',
  'nightingale_daily_refunded_units': 'Refunded Units',
  'nightingale_daily_accumulated_revenue': 'Accumulated Revenue',
  'nightingale_daily_avg_selling_price_asp': 'Average Selling Price (ASP)',
  'nightingale_daily_new': 'Daily New User',
  'nightingale_daily_sum_new': 'Sum.New User',
  'nightingale_daily_reactivated_users': 'Daily Reactivated User',
  'nightingale_daily_median_online_time': 'Median Playtime',
  'nightingale_daily_avg_median_online_time': 'Avg.Median Playtime',
  'nightingale_daily_aot_hour': 'Daily Average Playtime',
  'nightingale_daily_above_2hr_users': 'Playtime over 2h+ users',
  'nightingale_daily_avg_above_2hr_users': 'Avg.Playtime over 2h+ user',
  'nightingale_daily_median_session_time': 'Median Session',
  'nightingale_daily_avg_median_session_time': 'Avg.Median Session',
  'nightingale_daily_avg_session_time': 'Daily Avg.Session Length',
  'nightingale_daily_avg_session_cnt': 'Daily Avg.Session count',
  'nightingale_daily_pcu_active_users_rate': 'PCU/DAU',
  'nightingale_daily_avg_pcu_active_users_rate': 'Avg.PCU/Avg.DAU',
  'nightingale_daily_acu': 'ACU',
  'nightingale_daily_stickiness': 'Stickiness',
  'nightingale_avg_daily_stickiness': 'Avg.Stickiness',
  'nightingale_daily_active_retention_d2t1': 'Active Return D1(T-1)',
  'nightingale_daily_active_retention_d8t7': 'Active Return D7(T-7)',

  // V2
  'pc_daily_v2_above_2hr_users': 'Playtime over 2h+ new users',
  'pc_daily_v2_aot_hour': 'Avg.Playtime',
  'pc_daily_v2_avg_above_2hr_users': 'Avg.Playtime over 2h+ new users',
  'pc_daily_v2_median_session_time': 'Median Playtime Per Save',
  'pc_daily_v2_avg_median_session_time': 'Avg.Median Playtime Per Save',
  'pc_daily_v2_avg_session_time': 'Avg.Playtime Per Save',
  'pc_daily_v2_avg_session_cnt': 'Avg.Save Count',
  'pc_daily_v2_d1t1': 'D1(T-1)',
  'pc_daily_v2_d2t2': 'D2(T-2)',
  'pc_daily_v2_d7t7': 'D7(T-7)',
  'pc_daily_v2_median_session_time_h': 'Median Playtime Per Save(h)',
  // Calculation Bubble
  'data_calculation_specification': 'Data calculation specification',
  'bubble_completed': 'Completed',
  'bubble_calculating': 'calculating ...',

  'pc_console_overall_tab': 'Overall',
  'pc_console_breakdown_tab': 'Daily Breakdown',

  // V4
  'overview_monthly_breakdown_mtx_v4_platform': 'Revenue of Platform',
  'overview_monthly_breakdown_mtx_v4_country': 'Revenue of Top 10 Countries',
  'overview_monthly_breakdown_mtx_v4_region': 'Revenue of Top 10 Regions',
  'pc_overview_Revenue_v4': 'Revenue',
  'pc_overview_Revenue_v4_total': 'Sum Revenue',

  'overview_monthly_breakdown_dau_platform': 'DAU of Platform',
  'overview_monthly_breakdown_mau_platform': 'MAU of Platform',
  'overview_monthly_breakdown_wau_platform': 'WAU of Platform',
  'overview_monthly_breakdown_new_platform': 'New of Platform',

  'overview_monthly_breakdown_dau_country': 'DAU of Top 10 Countries',
  'overview_monthly_breakdown_mau_country': 'MAU of Top 10 Countries',
  'overview_monthly_breakdown_wau_country': 'WAU of Top 10 Countries',
  'overview_monthly_breakdown_new_country': 'New of Top 10 Countries',

  'overview_monthly_breakdown_dau_region': 'DAU of Top 10 Regions',
  'overview_monthly_breakdown_mau_region': 'MAU of Top 10 Regions',
  'overview_monthly_breakdown_wau_region': 'WAU of Top 10 Regions',
  'overview_monthly_breakdown_new_region': 'New of Top 10 Regions',

  'overview_monthly_breakdown_new_zone': 'New of Top 10 Zones',

  'overview_monthly_breakdown_units_platform': 'Base Game Units After Refund of Platform',
  'overview_monthly_breakdown_net_platform': 'Revenue After Refund & Tax of Platform',
  'overview_monthly_breakdown_mtx_platform': 'In-Game Revenue of Platform',

  'overview_monthly_breakdown_units_country': 'Base Game Units After Refund of Top 10 Countries',
  'overview_monthly_breakdown_net_country': 'Revenue After Refund & Tax of Top 10 Countries',
  'overview_monthly_breakdown_mtx_country': 'In-Game Revenue of Top 10 Countries',

  'overview_monthly_breakdown_units_region': 'Base Game Units After Refund of Top 10 Regions',
  'overview_monthly_breakdown_net_region': 'Revenue After Refund & Tax of Top 10 Regions',
  'overview_monthly_breakdown_mtx_region': 'In-Game Revenue of Top 10 Regions',
  'pc_v2_avg_session_time': 'Avg.Playtime Per Save(h)',
  'pc_v2_avg_session_cnt': 'Avg.Save Count',
  'pc_v2_daily_median_online_time': 'Median Playtime(h)',

  'pc_v3_daily_avg_median_online_time': 'Avg.Playtime(h)',
  'pc_overview_table_mtx_revenue($)': 'In-Game Revenue({unit})',

  // Overview Platform/Region/Country
  'gross_full_game_units_platform': 'Gross Base Game Units of Platform',
  'gross_full_game_units_country': 'Gross Base Game Units of Top 10 Countries',
  'gross_full_game_units_region': 'Gross Base Game Units of Top 10 Regions',

  'gross_revenue_platform': 'Gross Revenue of Platform',
  'gross_revenue_country': 'Gross Revenue of Top 10 Countries',
  'gross_revenue_region': 'Gross Revenue of Top 10 Regions',
};
